import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import SubNavigation from './SubNavigation';
import SVGParser from '../SVGParser';
import UniversalLink from '../UniversalLink';

export default ({ menuItem, openSub, id, active }) => {
  return (
    <li className={`navigation__item`}>
      {menuItem.path == '#' ? (
        <div className={`navigation__link ${active ? 'is--active' : ''}`} onClick={() => openSub(id)}>
          {menuItem.label}
          <SVGParser name="arrow-right" />
        </div>
      ) : (
        <UniversalLink to={menuItem.path} className="navigation__link">
          {menuItem.label}
        </UniversalLink>
      )}
    </li>
  );
};
